import type { FC } from "react";
import { cn } from "../../utils";
import type { GameFilterOption } from "./types";

type Props = {
  groupId: string;
  options: GameFilterOption[];
  selected?: string;
  clearable?: boolean;
  onSelect: (value: string | undefined) => void;
};

const GameFilterPills: FC<Props> = ({
  groupId,
  options,
  selected,
  clearable = true,
  onSelect,
}) => (
  <div data-slot="game-filter-pills" className="flex flex-wrap gap-2">
    {options.map((option) => {
      const pressed = option.value === selected;
      const locked = pressed && !clearable;

      return (
        <button
          key={option.value}
          type="button"
          aria-pressed={pressed}
          aria-disabled={locked || undefined}
          data-testid={`game-filter-${groupId}-${option.value}`}
          onClick={() => {
            if (locked) {
              return;
            }
            onSelect(pressed ? undefined : option.value);
          }}
          className={cn(
            "flex h-8 shrink-0 items-center rounded-full px-3 text-sm font-semibold whitespace-nowrap transition-colors",
            "focus-visible:ring-[3px] focus-visible:ring-ring/50 focus-visible:outline-none",
            locked ? "cursor-default" : "cursor-pointer",
            pressed
              ? "bg-primary/10 text-primary"
              : "bg-foreground/5 text-secondary-foreground hover:bg-muted",
          )}
        >
          {option.label}
        </button>
      );
    })}
  </div>
);

export default GameFilterPills;
